import { get, find } from 'lodash';

export default {
  validate: (question, visible, answers, payload, config, ln) => {
    const isVisible = find(payload.question, questionId => {
      return get(answers[questionId], 'part.metadata.SpecialType') === payload.specialType
    });

    return {
      visible: isVisible === undefined
    }
  }
};



// WEBPACK FOOTER //
// ./src/base/scripts/constraints/HideOnPartSpecialType.js